import { LocalizedLink } from "../../i18n/LocalizedLink";
import { useLocale } from "../../i18n/useLocale";

export function GuideStep({ number, title, body, note, noteLabel, visual }) {
  const { display } = useLocale();

  return (
    <li className="guide-step" id={`stap-${number}`}>
      <div className="guide-step-text">
        <span className="guide-step-number" aria-hidden="true">{number}</span>
        <div>
          <h2>{title}</h2>
          <p>{body}</p>
          {note && note.startsWith("/") && (
            <p className="guide-step-link">
              <LocalizedLink to={note}>{noteLabel || display.t("web.guides.readMore")}</LocalizedLink>
            </p>
          )}
        </div>
      </div>
      <div className="guide-step-visual" aria-hidden="true">
        {visual}
      </div>
    </li>
  );
}

export function GuideStepList({ intro, steps, visuals }) {
  return (
    <>
      <p className="info-page-intro">{intro}</p>
      <ol className="guide-steps">
        {steps.map((step, index) => (
          <GuideStep
            key={step.title}
            number={index + 1}
            title={step.title}
            body={step.body}
            note={step.note}
            noteLabel={step.noteLabel}
            visual={visuals[index]}
          />
        ))}
      </ol>
    </>
  );
}
